import { push } from "connected-react-router";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SelectedOpusSlider } from "../components/booths";
// import { selectedOpusDetail } from "../reducks/opuses/operations";
// import { getSelectedOpus } from "../reducks/opuses/selectors";
import { db } from "../firebase";
import { getBoothId } from "../reducks/booths/selectors";

const OpusDetail = () => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state);
  const boothId = getBoothId(selector);
  console.log(boothId);
  const [selectedOpus, setSelectedOpus] = useState([]);
  const [selectedOpusImages, setSelectedOpusImages] = useState([]);

  // const selectedOpus = getSelectedOpus(selector);
  const path = selector.router.location.pathname;
  const id = path.split("/opus/detail/")[1];
  console.log(selectedOpusImages);

  const createSelectedOpus = async () => {
    await db
      .collection("opuses")
      .doc(id)
      .get()
      .then((doc) => {
        const data = doc.data();
        setSelectedOpus(data);
      });
  };
  const createSelectedOpusImages = async () => {
    await db
      .collection("opuses")
      .doc(id)
      .get()
      .then((doc) => {
        const data = doc.data();
        const selectOpusImages = data.images;
        setSelectedOpusImages(selectOpusImages);
      });
  };

  useEffect(() => {
    createSelectedOpus();
    createSelectedOpusImages();
    // dispatch(selectedOpusDetail(id));
    // eslint-disable-next-line
  }, []);
  return (
    <section>
      {selectedOpus && (
        <div>
          <button onClick={() => dispatch(push("/boothlist"))}>リストへ</button>
          <h2>作品詳細</h2>
          <h2>{id}</h2>
          <SelectedOpusSlider key={selectedOpusImages} opusData={selectedOpusImages} />
          <h2>{selectedOpus.name}</h2>
          <h2>{selectedOpus.description}</h2>
          <h2>{selectedOpus.size}</h2>
          <h2>{selectedOpus.price}</h2>

          <button>購入申し込み</button>
        </div>
      )}
    </section>
  );
};

export default OpusDetail;
